(() => {
  document.querySelectorAll('[data-live-search]').forEach(form => {
    const input = form.querySelector('input[type="search"]');
    const results = form.querySelector('.live-search-results');
    const status = form.querySelector('.live-search-status');
    let timer, controller, revision = 0, composing = false;
    const update = () => {
      clearTimeout(timer);
      controller?.abort();
      const current = ++revision;
      const query = input.value.trim();
      results.replaceChildren();
      status.textContent = '';
      results.removeAttribute('aria-busy');
      if (!query || composing) return;
      timer = setTimeout(async () => {
        controller = new AbortController();
        status.textContent = 'Searching…';
        results.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(form.dataset.liveSearch, location.origin);
          url.search = new URLSearchParams({q: query, section_id: 'nw-predictive-search', 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last', 'resources[options][fields]': 'title,product_type,tag,variants.sku'});
          let response = await fetch(url, {signal: controller.signal});
          if (!response.ok) {
            const fallback = new URL(form.action, location.origin);
            fallback.search = new URLSearchParams({q: query, type: 'product', section_id: 'nw-predictive-search', 'options[prefix]': 'last'});
            response = await fetch(fallback, {signal: controller.signal});
          }
          if (!response.ok) throw new Error('Search unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = documentFragment.querySelector('[data-search-response]');
          if (!content) throw new Error('Search unavailable');
          if (revision !== current) return;
          results.replaceChildren(content);
          const count = Number(content.dataset.count);
          status.textContent = count ? `${count} suggested products` : 'No matching products. Try another keyword.';
        } catch (error) {
          if (error.name !== 'AbortError' && revision === current) status.textContent = 'Suggestions are unavailable. Press Enter to search all products.';
        } finally {
          if (revision === current) results.removeAttribute('aria-busy');
        }
      }, 220);
    };
    input.addEventListener('input', update);
    input.addEventListener('compositionstart', () => { composing = true; update(); });
    input.addEventListener('compositionend', () => { composing = false; update(); });
    form.closest('dialog')?.addEventListener('close', () => {
      clearTimeout(timer); controller?.abort(); revision++;
      results.removeAttribute('aria-busy'); status.textContent = '';
    });
    input.addEventListener('focus', () => { if (input.value.trim()) update(); });
  });
})();
